<div
  [class]="isInspecting ? 'product-bin-product bg-dark text-light' : 'product-bin-product'"
  [class.not-ranged]="productRef?.ranged === false"
  [class.is-container]="isContainer"
  [style]="rowIndentStyle"
  (click)="openInspector()"
  (contextmenu)="onProductRightClick($event)"
>
  @if (hasContainers) {
    <button
      type="button"
      class="container-toggle"
      (click)="toggleContainer($event)"
      [title]="isExpanded ? 'Collapse alternates' : 'Show alternates'"
    >
      <i [class]="isExpanded ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
    </button>
  }
  <div class="product-info">
    <div class="product-description">
      @if (isContainer) {
        <i class="bi bi-box me-1" title="Alternate configuration"></i>
      }
      {{ productRef?.description }}
    </div>
    <div class="product-status-badges">
      @if (productRef?.willAdd) { <span class="badge bg-success" title="Will be added">+</span> }
      @if (productRef?.willRemove) { <span class="badge bg-danger" title="Will be removed">−</span> }
      @if (productRef?.statusId === ProductStatus.NPI) { <span class="badge bg-info" title="New Product Introduction">NPI</span> }
      @if (productRef?.statusId === ProductStatus.Discontinued) { <span class="badge bg-secondary" title="Discontinued">DISC</span> }
      @if (productRef?.statusId === ProductStatus.ToBeDiscontinued) { <span class="badge bg-warning text-dark" title="To-Be Discontinued">TB DISC</span> }
      @if (productRef?.ranged === false) { <span class="badge badge-outline-secondary" title="Not Ranged">NR</span> }
      @if (isContainer && totalBaseUnits > 1) {
        <span class="badge bg-light text-dark border" title="Base units in this configuration">{{ totalBaseUnits }} units</span>
      }
    </div>
    <span class="badge text-bg-primary">{{ productRef?.uos }} {{ productRef?.unit }}</span>
    @if (hasTray || hasCase) {
      <div class="variant-chips">
        @if (hasTray) {
          <span class="variant-chip variant-chip-tray" [class.no-drag]="!canEdit" (mousedown)="onVariantMouseDown($event, 1)" title="Drag the tray onto the planogram">
            <i class="bi bi-stack"></i> Tray
            @if (productRef?.defaultCasepackConfig === 1) { <i class="bi bi-star-fill variant-default" title="Default configuration"></i> }
          </span>
        }
        @if (hasCase) {
          <span class="variant-chip variant-chip-case" [class.no-drag]="!canEdit" (mousedown)="onVariantMouseDown($event, 2)" title="Drag the case onto the planogram">
            <i class="bi bi-box-seam"></i> Case
            @if (productRef?.defaultCasepackConfig === 2) { <i class="bi bi-star-fill variant-default" title="Default configuration"></i> }
          </span>
        }
      </div>
    }
    <div class="product-details w-100 m-0">
      <span class="product-barcode">
        <span
          [class]="
            (isProductOnPlanogram(productRef?.productId) | async)
              ? 'product-check product-checked'
              : 'product-check product-unchecked'
          "
        >
          <ng-template #other_content><i class="bi bi-x-lg"></i></ng-template>
        </span>
        {{ productRef?.barcode }}
      </span>
      <span class="product-total badge text-bg-primary ms-auto">
        {{ getTotalOfProductOnPlanogram(productRef?.productId) | async }}
      </span>
    </div>
  </div>
  <div
    class="product-image"
    [class.no-drag]="!canEdit"
    (mousedown)="onMouseDown($event)"
  >
    <app-image
      [orientation]="productRef?.orientation"
      [squeeze]="0"
      [productId]="productRef?.productId"
      [thumbnail]="true"
    >
    </app-image>
  </div>
</div>

@if (hasContainers && isExpanded) {
  <div class="container-children">
    @for (container of directContainers; track container.productId) {
      <app-product-bin-product
        [productRef]="container"
        [isContainer]="true"
        [depth]="depth + 1"
      ></app-product-bin-product>
    }
  </div>
}
